import { render, staticRenderFns } from "./AddressLength.vue?vue&type=template&id=928b707a"
import script from "./AddressLength.vue?vue&type=script&lang=ts"
export * from "./AddressLength.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports